import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IKnowledgeTest} from './useKnowledgeTest';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {ICollectionWork} from './useCollectionWork';

export enum ContestType {
  知识竞赛类 = 1,
  作品征集类 = 2,
}

export enum ContestStatus {
  尚未开始 = 1,
  进行中 = 2,
  已结束 = 3,
}

export const ContestStatusColor = ['warning', 'warning', 'success', 'error'];
export const ContestTypeColor = ['warning', 'blue', 'purple'];

export interface IContest {
  name: string;
  status: ContestStatus;
  type: ContestType;
  isHide: boolean;
  simulationKnowledgeTestId: number;
  regulationKnowledgeTestId: number;
  collectionWork: ICollectionWork;
  simulationKnowledgeTest: IKnowledgeTest;
  regulationKnowledgeTest: IKnowledgeTest;
  id: number;
  createdTime: string;
}

export interface IContestSaveParams {
  id?: number;
  name: string;
  type: ContestType;
  status: ContestStatus;
  isHide: boolean;
}

export interface IContestListParams {
  includeHide?: boolean;
}

export default class UseContest {
  static save() {
    return usePost<IContestSaveParams, IContest>('contest/save', {});
  }
  static list() {
    return useGet<IContestListParams, IContest[]>('contest/list', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IContest>('contest/queryById', {});
  }
}
